module.exports = __webpack_public_path__ + "img/2.4940bc67.png";